import {
  Configuration,
  Dashboard,
  Master,
  Project,
  Product,
  JobCard,
  Reports,
  SalesOrder,
} from "Components/constants/LayoutMenu";
import { CustomerLabel, StaffLabel } from "Components/constants/Staff";
import { materialLabel } from "Components/constants/Material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { materialGroupLabel } from "Components/constants/MaterialGroup";
import {
  PartRequiaitionLabel,
  PurchaseOrderLabel,
} from "Components/constants/PurchaseOrder";  
import { vendorLabel } from "Components/constants/Vendor";
import { TECHNICIAN_LABEL } from "Components/constants/Technician";
import { getItem } from "Components/constants/SessionStores";
import { ORDER_LABEL } from "Components/constants/Order";
import { moduleName } from "Components/constants/Common";
import { STORE_LABEL } from "Components/constants/Store";
import { makeLabel } from "Components/constants/ManuFacturer";
import { servicesLabel } from "Components/constants/Services";
import { HSNSACLabel } from "Components/constants/HsnSac";
import { OrderServicesLabel } from "Components/constants/OrderService";
import { RepairOrderOpening } from "Components/constants/RepairOrderOpening";
import { PartsIssueDetailsLabel } from "Components/constants/PartsIssueDetails";
import { RepairOrderClosingLabel } from "Components/constants/RepairOrderClosing";
import { RepairOrderReopenLabel } from "Components/constants/RepairOrderReopen";
import { RoPurchaseOrder } from "Components/constants/RoPurchaseOrder";
import { POReturn, ReturnRONPOLabel, ROReturn } from "Components/constants/ReturnRONPO";

const Navdata = () => {
  const history = useNavigate();
  let permissions = JSON.parse(String(getItem("permissions")));
  const [isDashboard, setIsDashboard] = useState<boolean>(false);
  const [isMaster, setIsMaster] = useState<boolean>(false);
  const [isConfiguration, setIsConfiguration] = useState<boolean>(false);
  const [isProject, setIsProject] = useState<boolean>(false);
  const [isProduct, setIsProduct] = useState<boolean>(false);
  const [isPurchaseOrder, setIsPurchaseOrder] = useState<boolean>(false);
  const [isOrder, setIsOrder] = useState<boolean>(false);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");
  const [isJobCard, setIsJobCard] = useState<boolean>(false);
  const [isReports, setIsReports] = useState<boolean>(false);
  const [isOrderService, setIsOrderService] = useState<boolean>(false);
  const [isReturn, setIsReturn] = useState<boolean>(false);
  const [isSalesOrder, setIsSalesOrder] = useState<boolean>(false);
  let allowedModules: any[] =
    permissions?.map((perm: any) => perm.module_name) || [];

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("sub-items");
        const getID = document.getElementById(id) as HTMLElement;
        if (getID) getID.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== Dashboard) {
      setIsDashboard(false);
    }
    if (iscurrentState !== Configuration) {
      setIsConfiguration(false);
    }
    if (iscurrentState !== Master) {
      setIsMaster(false);
    }
    if (iscurrentState !== Product) {
      setIsProduct(false);
    }
    if (iscurrentState !== PurchaseOrderLabel) {
      setIsPurchaseOrder(false);
    }
    if (iscurrentState !== ORDER_LABEL) {
      setIsOrder(false);
    }
    if (iscurrentState != "Reports") {
      setIsReports(false);
    }
    if (iscurrentState !== OrderServicesLabel) {
      setIsOrderService(false);
    }
    if (iscurrentState !== SalesOrder) {
      setIsSalesOrder(false);
    }
    if (iscurrentState !== ReturnRONPOLabel) {
      setIsReturn(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isConfiguration,
    isMaster,
    isProduct,
    isPurchaseOrder,
    isOrder,
    isReports,
    isOrderService,
    isReturn,
  ]);

  const menuItems: any = [
    {
      id: "dashboard",
      label: Dashboard,
      icon: "mdi mdi-speedometer",
      link: "/dashboard",
      module_name: moduleName.Dashboard,
      stateVariables: isDashboard,
      click: function (e: any) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState(Dashboard);
        updateIconSidebar(e);
      },
    },
    {
      id: "master",
      label: Master,
      icon: "mdi mdi-apps",
      link: "/#",
      module_name: "Master",
      stateVariables: isMaster,
      click: function (e: any) {
        e.preventDefault();
        setIsMaster(!isMaster);
        setIscurrentState("Master");
        updateIconSidebar(e);
      },
      subItems: [
        // {
        //   id: "store",
        //   label: STORE_LABEL,
        //   link: "/store",
        //   parentId: "master",
        //   module_name: moduleName.Store,
        // },
        {
          id: "material",
          label: materialLabel,
          link: "/material",
          parentId: "master",
          module_name: moduleName.Material,
        },
        {
          id: "materialGroup",
          label: materialGroupLabel,
          link: "/material-group",
          parentId: "master",
          module_name: moduleName.MaterialGroup,
        },
        {
          id: "make",
          label: makeLabel,
          link: "/make",
          parentId: "master",
          module_name: moduleName.Make,
        },
        {
          id: "vendor",
          label: vendorLabel,
          link: "/vendor",
          parentId: "master",
          module_name: moduleName.Vendor,
        },
        {
          id: "customer",
          label: CustomerLabel,
          link: "/customer",
          parentId: "master",
          module_name: moduleName.Customers,
        },
        {
          id: "technician",
          label: TECHNICIAN_LABEL,
          link: "/technician",
          parentId: "master",
          module_name: moduleName.Technician,
        },
        {
          id: "staff",
          label: StaffLabel,
          link: "/staff",
          parentId: "master",
          module_name: moduleName.Staff,
        },
        {
          id: "services",
          label: servicesLabel,
          link: "/services",
          parentId: "master",
          module_name: moduleName.Service,
        },
        {
          id: "hsnsac",
          label: HSNSACLabel,
          link: "/hsn_sac",
          parentId: "master",
          module_name: moduleName.HsnSac,
        },
      ],
    },
    {
      id: "project",
      label: Project,
      icon: "mdi mdi-apps-box",
      link: "/project",
      module_name: moduleName.Project,
      stateVariables: isProject,
      click: function (e: any) {
        e.preventDefault();
        setIsProject(!isProject);
        setIscurrentState(Project);
        updateIconSidebar(e);
      },
    },
    {
      id: "product",
      label: Product,
      icon: "mdi mdi-store",
      link: "/product",
      module_name: moduleName.Product,
      stateVariables: isProduct,
      click: function (e: any) {
        e.preventDefault();
        setIsProduct(!isProduct);
        setIscurrentState(Product);
        updateIconSidebar(e);
      },
    },
    {
      id: "purchase-order",
      label: PurchaseOrderLabel,
      icon: "mdi mdi-briefcase-arrow-up-down",
      link: "/#",
      module_name: "Purchase Order",
      stateVariables: isPurchaseOrder,
      click: function (e: any) {
        e.preventDefault();
        setIsPurchaseOrder(!isPurchaseOrder);
        setIscurrentState(PurchaseOrderLabel);
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "indentation",
          label: "Generation",
          link: "/indentation",
          parentId: "purchase-order",
          module_name: moduleName.Generation,
        },
        {
          id: "purchase-order",
          label: "Received",
          link: "/purchase-order",
          parentId: "purchase-order",
          module_name: moduleName.Received,
        },
      ],
    },
    {
      id: "order",
      label: "Order",
      icon: "mdi mdi-cart",
      link: "/order",
      module_name: moduleName.Orders,
      stateVariables: isOrder,
      click: function (e: any) {
        e.preventDefault();
        setIsOrder(!isOrder);
        setIscurrentState("Order");
        updateIconSidebar(e);
      },
    },
    {
      id: "sales-order",
      label: SalesOrder,
      icon: "mdi mdi-briefcase-arrow-up-down",
      link: "/#",
      stateVariables: isSalesOrder,
      click: function (e: any) {
        e.preventDefault();
        setIsSalesOrder(!isSalesOrder);
        setIscurrentState(SalesOrder);
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "quotation",
          label: "Quotation",
          link: "/quotation",
          parentId: "sales-order",
          module_name: moduleName.Quotation,
        },
        {
          id: "work-order",
          label: "Work Order",
          link: "/work-order",
          parentId: "sales-order",
          module_name: moduleName.WorkOrder,
        },
        {
          id: "performa-invoice",
          label: "Proforma Invoice",
          link: "/proforma-invoice",
          parentId: "sales-order",
          module_name: moduleName.ProformaInvoice,
        },
        {
          id: "tax-invoice",
          label: "Tax invoice",
          link: "/tax-invoice",
          parentId: "sales-order",
          module_name: moduleName.TaxInvoice,
        },
        {
          id: "credit-note",
          label: "Credit Note",
          link: "/credit-note",
          parentId: "sales-order",
          module_name: moduleName.CreditNote,
        },
      ],
    },
    //for future purpose
    // {
    //   id: "jobCard",
    //   label: "Job Card",
    //   icon: "mdi mdi-shield-account-outline",
    //   link: "/job-card",
    //   module_name: moduleName.JobCard,
    //   stateVariables: isJobCard,
    //   click: function (e: any) {
    //     e.preventDefault();
    //     setIsJobCard(!isJobCard);
    //     setIscurrentState("Job Card");
    //     updateIconSidebar(e);
    //   },
    // },
    //for future purpose
    // {
    //   id: "reports",
    //   label: Reports,
    //   icon: "mdi mdi-poll",
    //   link: "/#",
    //   stateVariables: isReports,
    //   module_name: moduleName.Reports,
    //   click: function (e: any) {
    //     e.preventDefault();
    //     setIsReports(!isReports);
    //     setIscurrentState("Reports");
    //     updateIconSidebar(e);
    //   },
    //   subItems: [
    //     {
    //       id: "order-report",
    //       label: "Order Report",
    //       link: "/order-report",
    //       parentId: "reports",
    //       module_name: moduleName.Reports,
    //     },
    //     {
    //       id: "po-report",
    //       label: "PO Report",
    //       link: "/purchase-order-report",
    //       parentId: "reports",
    //       module_name: moduleName.Reports,
    //     },
    //     {
    //       id: "job-card-report",
    //       label: "Job Card Report",
    //       link: "/job-card-report",
    //       parentId: "reports",
    //       module_name: moduleName.Reports,
    //     },
    //   ],
    // },
    {
      id: "order-services",
      label: OrderServicesLabel,
      icon: "mdi mdi-toolbox-outline",
      link: "/#",
      module_name: 'Services',
      stateVariables: isOrderService,
      click: function (e: any) {
        e.preventDefault();
        setIsOrderService(!isOrderService);
        setIscurrentState(OrderServicesLabel);
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "repairOrderOpening",
          label: RepairOrderOpening,
          link: "/repairOrder",
          parentId: "order-services",
          module_name: moduleName.RepairOrderOpening,
        },
        {
          id: "partrequistion",
          label: PartRequiaitionLabel,
          link: "/partRequisition",
          parentId: "order-services",
          module_name: moduleName.RepairOrderOpening,
        },
        {
          id: "roPurchaseOrder",
          label: RoPurchaseOrder,
          link: "/RoPurchaseOrder",
          parentId: "order-services",
          module_name: moduleName.PurchaseOrder,
        },
        {
          id: "partsIssueDetails",
          label: PartsIssueDetailsLabel,
          link: "/partIssueDetails",
          parentId: "order-services",
          module_name: moduleName.PartsIssueDetaiils,
        },
        {
          id: "repairOrderClosing",
          label: RepairOrderClosingLabel,
          link: "/repairOrderClosing",
          parentId: "order-services",
          module_name: moduleName.RepairOrderClosing,
        },
        {
          id: "repairOrderReOpening",
          label: RepairOrderReopenLabel,
          link: "/repairOrderReOpen",
          parentId: "order-services",
          module_name: moduleName.RepairOrderReopen,
        },
      ],
    },
    {
      id: "returnRoNPo",
      label: ReturnRONPOLabel,
      icon: "mdi mdi-keyboard-return",
      link: "/#",
      module_name: 'Return',
      stateVariables: isReturn,
      click: function (e: any) {
        e.preventDefault();
        setIsReturn(!isReturn);
        setIscurrentState(ReturnRONPOLabel);
        updateIconSidebar(e);
      },
      subItems: [
        {
          id: "poreturn",
          label: POReturn,
          link: "/POReturn",
          parentId: "order-services",
          module_name: moduleName.ReturnPurchaseOrder,
        },
        {
          id: "roReturn",
          label: ROReturn,
          link: "/ROReturn",
          parentId: "order-services",
          module_name: moduleName.ReturnRepairOrder,
        },
      ],
    },

    {
      id: "configuration",
      label: Configuration,
      icon: "mdi mdi-cog-outline",
      link: "/role",
      module_name: moduleName.Configuration,
      stateVariables: isConfiguration,
      click: function (e: any) {
        e.preventDefault();
        setIsConfiguration(!isConfiguration);
        setIscurrentState(Configuration);
        updateIconSidebar(e);
      },
    },
  ];

  const filteredMenuItems = menuItems.filter((item: any) => {
    if (item.subItems) {
      item.subItems = item.subItems.filter((subItem: any) =>
        allowedModules.includes(subItem.module_name)
      );
    }
    return allowedModules.includes(item.module_name) || item.subItems?.length;
  });

  return <React.Fragment>{filteredMenuItems}</React.Fragment>;
};

export default Navdata;
